import Link from 'next/link'

import PostActions from '@/components/post-actions/PostActions'

import TermLinks from '@/components/term-links/TermLinks'
import EventDates from '@/components/event-dates/EventDates'

export default function EventSidebar({
  eventDates,
  timezone,
  timezoneModal,
  location,
  formats,
  eventTypes,
  price,
  bookingLink = {},
  actions = { share: true, download: true, print: true, bookmark: true },
  postId,
}) {
  return (
    <div className="flex flex-col items-end gap-s">
      <div className="w-full overflow-hidden rounded-md bg-theme p-px gradient-angle-[to_right] theme--gradient-light gradient--border">
        <div className="w-full rounded-md bg-theme p-l text-fg theme--base-0 s:p-m">
          <div className="flex flex-col gap-l l:flex-row l:items-center s:flex-col s:items-start s:gap-m">
            <ul className="flex grow flex-col gap-l l:grid l:grid-cols-2 l:gap-s s:grid-cols-1">
              {eventDates ? (
                <li>
                  <span className="h6 mb-0 l:mb-0">Date & Time</span>
                  <div className="p--small mb-0">
                    <EventDates
                      dates={eventDates}
                      timezone={timezone}
                      timezoneModal={timezoneModal}
                      full={true}
                    />
                  </div>
                </li>
              ) : null}

              {location || (formats && formats.length) ? (
                <li>
                  <span className="h6 mb-0 l:mb-0">Location</span>
                  {location ? <p className="p--small mb-0">{location}</p> : null}
                  <TermLinks terms={formats} postType="all-events" />
                </li>
              ) : null}

              {eventTypes && eventTypes.length ? (
                <li>
                  <span className="h6 mb-0 l:mb-0">Type</span>
                  <TermLinks terms={eventTypes} postType="all-events" />
                </li>
              ) : null}

              {price ? (
                <li>
                  <span className="h6 mb-0 l:mb-0">Price</span>
                  <p className="p--small mb-0">{price}</p>
                </li>
              ) : null}
            </ul>

            {bookingLink.url ? (
              <Link
                href={bookingLink.url}
                target={bookingLink?.target ? bookingLink.target : '_self'}
                className="btn btn--solid btn--small shrink-0 s:w-full l-up:w-full">
                {bookingLink?.title ? bookingLink.title : 'Book Now'}
              </Link>
            ) : null}
          </div>
        </div>
      </div>
      <div className="l:hidden">
        <PostActions actions={actions} postId={postId} />
      </div>
    </div>
  )
}
